import script from "./SelectWorkstationModal.vue?vue&type=script&setup=true&lang=js"
export * from "./SelectWorkstationModal.vue?vue&type=script&setup=true&lang=js"

import "./SelectWorkstationModal.vue?vue&type=style&index=0&id=25f2494d&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25f2494d"]])

export default __exports__